import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { getMaterial, postMaterial } from "../../../redux/actions";
import styles from "./crearMaterial.module.css";

const GestionMaterial = () => {
  const dispatch = useDispatch();
  const materiales = useSelector((state) => state.material);
  const [nuevoMaterial, setNuevoMaterial] = useState("");

  useEffect(() => {
    dispatch(getMaterial());
  }, [dispatch]);

  const handleCrear = async () => {
    if (!nuevoMaterial.trim()) {
      Swal.fire("Error", "Debe escribir un nombre de material.", "error");
      return;
    }

    try {
      await dispatch(postMaterial({ nombre: nuevoMaterial.trim() }));
      Swal.fire("Éxito", "Material creado correctamente.", "success");
      setNuevoMaterial("");
      dispatch(getMaterial());
    } catch (error) {
      const errorMsg =
        error?.response?.data?.error ||
        error?.message ||
        "Hubo un problema al crear el material.";
      Swal.fire("Error", errorMsg, "error");
    }
  };

  return (
    <div className={styles.formContainer}>
      <h2 className={styles.title}>Gestión de material</h2>

      <input
        type="text"
        placeholder="Escriba el material"
        value={nuevoMaterial}
        onChange={(e) => setNuevoMaterial(e.target.value)}
        className={styles.input}
      />

      <button onClick={handleCrear} className={styles.button}>
        Crear material
      </button>

      <select className={styles.select}>
        <option value="">Seleccione un material</option>
        {materiales.map((mat) => (
          <option key={mat.id} value={mat.id}>{mat.nombre}</option>
        ))}
      </select>
    </div>
  );
};

export default GestionMaterial;
